import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

// Components
import Badge from "components/Badge";

DateBadge.propTypes = {
    shipmentDate: PropTypes.string.isRequired,
};

function DateBadge({shipmentDate, ...props}) {
    const [diffDays, setDiffDays] = React.useState(0);

    useEffect(() => {
        if (!shipmentDate) {
            return;
        }

        const date = new Date(shipmentDate);
        setDiffDays(dateDiffInDays(date));
    }, [shipmentDate]);

    function dateDiffInDays(date) {
        const today = new Date();

        const millisecondsPerDay = 1000 * 60 * 60 * 24;

        const utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

        return Math.floor((utc2 - utc1) / millisecondsPerDay);
    }

    function getBadgeColor() {
        if (diffDays >= 0 && diffDays <= 6) {
            return 'online';
        } else if (diffDays >= 7 && diffDays <= 14) {
            return 'warning';
        } else {
            return 'error';
        }
    }

    return (
        <Badge
            rounded={true}
            size={'xl'}
            color={getBadgeColor()}
            isBold={false}
        >
            J+{dateDiffInDays(new Date(shipmentDate))}
        </Badge>
    );
}

export default DateBadge;
